import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import translationAR from './locales/ar/translation.json';
import translationAT from './locales/at/translation.json';
import translationBE from './locales/be/translation.json';
import translationCA from './locales/ca/translation.json';
import translationCH from './locales/ch/translation.json';
import translationCL from './locales/cl/translation.json';
import translationCO from './locales/co/translation.json';
import translationCS from './locales/cs/translation.json';
import translationDA from './locales/da/translation.json';
import translationDE from './locales/de/translation.json';
import translationEL from './locales/el/translation.json';
import translationEN from './locales/en/translation.json';
import translationES from './locales/es/translation.json';
import translationET from './locales/et/translation.json';
import translationFI from './locales/fi/translation.json';
import translationFR from './locales/fr/translation.json';
import translationHU from './locales/hu/translation.json';
import translationMX from './locales/mx/translation.json';
import translationIE from './locales/ie/translation.json';
import translationIT from './locales/it/translation.json';
import translationJA from './locales/ja/translation.json';
import translationLT from './locales/lt/translation.json';
import translationLV from './locales/lv/translation.json';
import translationNL from './locales/nl/translation.json';
import translationNO from './locales/no/translation.json';
import translationPE from './locales/pe/translation.json';
import translationPL from './locales/pl/translation.json';
import translationPT from './locales/pt/translation.json';
import translationRO from './locales/ro/translation.json';
import translationSE from './locales/se/translation.json';
import translationSK from './locales/sk/translation.json';
import translationSL from './locales/sl/translation.json';
import translationSV from './locales/sv/translation.json';
import translationTH from './locales/th/translation.json';
import translationTR from './locales/tr/translation.json';
import translationVN from './locales/vn/translation.json';
import translationZH from './locales/zh/translation.json';
import translationEU from './locales/eu/translation.json';

// primark translation override files
import translationPrimarkAT from './locales/at/primark.json';
import translationPrimarkBE from './locales/be/primark.json';
import translationPrimarkCH from './locales/ch/primark.json';
import translationPrimarkCS from './locales/cs/primark.json';
import translationPrimarkDE from './locales/de/primark.json';
import translationPrimarkES from './locales/es/primark.json';
import translationPrimarkFR from './locales/fr/primark.json';
import translationPrimarkHU from './locales/hu/primark.json';
import translationPrimarkIT from './locales/it/primark.json';
import translationPrimarkNL from './locales/nl/primark.json';
import translationPrimarkPL from './locales/pl/primark.json';
import translationPrimarkPT from './locales/pt/primark.json';
import translationPrimarkRO from './locales/ro/primark.json';
import translationPrimarkSK from './locales/sk/primark.json';
import translationPrimarkSL from './locales/sl/primark.json';
import translationCirclekET from './locales/et/circlek.json';
import translationCirclekLT from './locales/lt/circlek.json';
import translationCirclekLV from './locales/lv/circlek.json';
import translationCirclekPL from './locales/pl/circlek.json';
import translationCirclekSV from './locales/sv/circlek.json';

// circlek translation override files
import translationCirclekEN from './locales/en/circlek.json';

// pandora translation override files
import translationPandoraCS from './locales/cs/pandora.json';
import translationPandoraEN from './locales/en/pandora.json';
import translationPandoraPL from './locales/pl/pandora.json';
import translationPandoraAT from './locales/at/pandora.json';
import translationPandoraDE from './locales/de/pandora.json';
import translationPandoraHU from './locales/hu/pandora.json';
import translationPandoraNL from './locales/nl/pandora.json';
import translationPandoraBE from './locales/be/pandora.json';
import translationPandoraFR from './locales/fr/pandora.json';
import translationPandoraES from './locales/es/pandora.json';
import translationPandoraPT from './locales/pt/pandora.json';

// tkmaxx translation override files
import translationTkmaxxAT from './locales/at/tkmaxx.json';
import translationTkmaxxDE from './locales/de/tkmaxx.json';
import translationTkmaxxNL from './locales/nl/tkmaxx.json';
import translationTkmaxxPL from './locales/pl/tkmaxx.json';
import translationTkmaxxEN from './locales/en/tkmaxx.json';
import translationTkmaxxCA from './locales/ca/tkmaxx.json';
import translationTkmaxxES from './locales/es/tkmaxx.json';
import translationTkmaxxEU from './locales/eu/tkmaxx.json';

// homesense translation override files
import translationHomesenseEN from "./locales/en/homesense.json";

// Tescogiftcard translation override files
import translationTescogiftcardEN from "./locales/en/tescogiftcards.json";

// lacoste translation override files
import translationLacosteDE from "./locales/de/lacoste.json";
import translationLacosteEN from "./locales/en/lacoste.json";
import translationLacosteES from "./locales/es/lacoste.json";
import translationLacosteIT from "./locales/it/lacoste.json";
import translationLacosteCH from "./locales/ch/lacoste.json";
import translationLacosteFR from "./locales/fr/lacoste.json";
// the translations
const resources = {
  ar: {
    translation: translationAR
  },
  at: {
    translation: translationAT,
    pandora: translationPandoraAT,
    primark: translationPrimarkAT,
    tkmaxx: translationTkmaxxAT
  },
  be: {
    translation: translationBE,
    primark: translationPrimarkBE,
    pandora: translationPandoraBE
  },
  ca: {
    translation: translationCA,
    tkmaxx: translationTkmaxxCA
  },
  ch: {
    translation: translationCH,
    primark: translationPrimarkCH,
    lacoste: translationLacosteCH
  },
  cl: {
    translation: translationCL
  },
  co: {
    translation: translationCO
  },
  cs: {
    translation: translationCS,
    primark: translationPrimarkCS,
    pandora: translationPandoraCS
  },
  da: {
    translation: translationDA,
  },
  de: {
    translation: translationDE,
    pandora: translationPandoraDE,
    primark: translationPrimarkDE,
    tkmaxx: translationTkmaxxDE,
    lacoste: translationLacosteDE
  },
  el: {
    translation: translationEL,
  },
  en: {
    translation: translationEN,
    circlek: translationCirclekEN,
    pandora: translationPandoraEN,
    tkmaxx: translationTkmaxxEN,
    homesense: translationHomesenseEN,
    lacoste: translationLacosteEN,
    tescogiftcard: translationTescogiftcardEN
  },
  es: {
    translation: translationES,
    primark: translationPrimarkES,
    tkmaxx: translationTkmaxxES,
    lacoste: translationLacosteES,
    pandora: translationPandoraES
  },
  et: {
    translation: translationET,
    circlek: translationCirclekET
  },
  eu: {
    translation: translationEU,
    tkmaxx: translationTkmaxxEU
  },
  fi: {
    translation: translationFI,
  },
  fr: {
    translation: translationFR,
    primark: translationPrimarkFR,
    pandora: translationPandoraFR,
    lacoste:translationLacosteFR
  },
  hu: {
    translation: translationHU,
    primark: translationPrimarkHU,
    pandora: translationPandoraHU
  },
  ie: {
    translation: translationIE,
    tkmaxx: translationTkmaxxEN
  },
  it: {
    translation: translationIT,
    primark: translationPrimarkIT,
    lacoste: translationLacosteIT
  },
  ja: {
    translation: translationJA,
  },
  lt: {
    translation: translationLT,
    circlek: translationCirclekLT
  },
  lv: {
    translation: translationLV,
    circlek: translationCirclekLV
  },
  mx: {
    translation: translationMX
  },
  nl: {
    translation: translationNL,
    primark: translationPrimarkNL,
    tkmaxx: translationTkmaxxNL,
    pandora: translationPandoraNL
  },
  no: {
    translation: translationNO,
  },
  pl: {
    translation: translationPL,
    primark: translationPrimarkPL,
    circlek: translationCirclekPL,
    pandora: translationPandoraPL,
    tkmaxx: translationTkmaxxPL
  },
  pe: {
    translation: translationPE
  },
  pt: {
    translation: translationPT,
    primark: translationPrimarkPT,
    pandora: translationPandoraPT
  },
  ro: {
    translation: translationRO,
    primark: translationPrimarkRO
  },
  se: {
    translation: translationSE
  },
  sk: {
    translation: translationSK,
    primark: translationPrimarkSK,
  },
  sl: {
    translation: translationSL,
    primark: translationPrimarkSL
  },
  sv: {
    translation: translationSV,
    circlek: translationCirclekSV
  },
  th: {
    translation: translationTH,
  },
  tr: {
    translation: translationTR,
  },
  uk: {
    translation: translationEN,
    tkmaxx: translationTkmaxxEN
  },
  vn: {
    translation: translationVN,
  },
  zh: {
    translation: translationZH,
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    ns: ['translation', 'primark', 'circlek', 'pandora', 'tkmaxx', 'homesense','lacoste'], // for those using custom translations, you will need to add your new namespace here
    defaultNS: "translation",
    fallbackNS: "translation",
    lng: 'en',
    fallbackLng: 'en', // use en if detected lng is not available

    keySeparator: '.', // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    debug: false,
  });

export default i18n;
